import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ClusterApi } from "@cluster/web-components";
import { selectAlertsWithVisibility, selectAlertsVisibility } from '../store/selectors/alerts';
import { doRoute } from '../store/actions/location';
import { ALERTS_VISIBILITY } from '../store/reducers/system';
import RadioTabs from '../Forms/RadioTabs';
import { doSetAlertsVisibility, doSetMobileMenuOpen } from '../store/actions/system';
import { ReactComponent as GoToIcon } from '../images/goto.svg'
import { ReactComponent as AlertIcon } from '../images/alert.svg'
import { selectCurrentChannelId, selectMobileMenuOpen } from '../store/selectors';
import { ROUTE_ACTIONS } from '../store/routes';
import firebase from '../lib/firebase';

import styles from './NewsAlerts.module.scss'

export default function Alerts() {
  const alerts = useSelector(selectAlertsWithVisibility);
  const alertsVisibility = useSelector(selectAlertsVisibility);
  const dispatch = useDispatch();

  const changeVisibility = (visibility: ALERTS_VISIBILITY) => {
    dispatch(doSetAlertsVisibility(visibility));
  }

  let items = [];

  for (const alert of alerts) {
    items.push(React.createElement(Alert,
      {
        ...alert,
        key: alert.id,
      }
    ));
  }

  const tabs = [
    {
      value: ALERTS_VISIBILITY.ALL,
      title: "All Alerts",
    }, {
      value: ALERTS_VISIBILITY.CHANNEL,
      title: "Channel Alerts"
    }
  ]

  return (
    <div className={styles.list}>
      <RadioTabs onChange={changeVisibility} defaultValue={alertsVisibility} tabs={tabs} />
      { items.length>0 ? items : <div className={styles.message}>No alerts available.</div> }
    </div>
  );
}

type AlertProps = ClusterApi.Alert & {
  id: number,
}

function Alert(props: AlertProps) {
  const dispatch = useDispatch();
  const currentChannelId = useSelector(selectCurrentChannelId);
  const mobileMenuOpen = useSelector(selectMobileMenuOpen);

  // Don't push to history if it's the same channel
  const sameChannel = currentChannelId === props.board.id;

  const goToCell = () => {
    dispatch(doRoute(ROUTE_ACTIONS.CHANNEL,{payload: {id: props.board.id}, query: {pan: props.cell.id?.toString()}}, sameChannel));

    if (mobileMenuOpen) {
      dispatch(doSetMobileMenuOpen(false));
    }

    // Firebase event
    firebase.analytics.logEvent("focus_event", {type: "alert", cell_id: props.cell.id});
  }

  return (
    <div className={styles.alert} onClick={goToCell}>
      <div className={styles.imageWrapper}>
        <AlertIcon className={styles.alertImage} />
      </div>
      <div className={styles.itemTitle}>
        {props.cell.title}
      </div>
      <div className={styles.itemDesc}>
        {props.message}
      </div>
      <div className={styles.dateAuthor}>
        {props.board.name}
      </div>
      <button className={styles.button}><GoToIcon /></button>
    </div>
  );
}